import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { resourceScopeCleared, userScopeCleared } from '@krp/client-runtime'

import type { DeliveryIntentState, OperationFilter, ReconcileState } from './types'

/**
 * Намерение человека в окне доставки: какой срез операций смотреть, и ход
 * запущенной сверки. Операций и счётчиков здесь НЕТ — они в кэше RTK Query.
 * Срок жизни — `screen`: выбор среза не стоит сохранения.
 */
export const OPERATION_FILTERS: readonly OperationFilter[] = ['all', 'active', 'unknown', 'failed', 'succeeded']

const initialState: DeliveryIntentState = { filters: {}, reconcile: {} }

export const IDLE_RECONCILE: ReconcileState = { busy: false, failure: null }

const deliverySlice = createSlice({
  name: 'aqsi/delivery',
  initialState,
  reducers: {
    filterChosen(state, action: PayloadAction<{ resourceId: string; filter: OperationFilter }>) {
      state.filters[action.payload.resourceId] = action.payload.filter
    },
    reconcileStarted(state, action: PayloadAction<{ resourceId: string }>) {
      state.reconcile[action.payload.resourceId] = { busy: true, failure: null }
    },
    reconcileFinished(state, action: PayloadAction<{ resourceId: string }>) {
      state.reconcile[action.payload.resourceId] = IDLE_RECONCILE
    },
    reconcileFailed(state, action: PayloadAction<{ resourceId: string; failure: NonNullable<ReconcileState['failure']> }>) {
      state.reconcile[action.payload.resourceId] = { busy: false, failure: action.payload.failure }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userScopeCleared, () => initialState)
    builder.addCase(resourceScopeCleared, (state, action) => {
      delete state.filters[action.payload.resourceId]
      delete state.reconcile[action.payload.resourceId]
    })
  },
})

export const { filterChosen, reconcileStarted, reconcileFinished, reconcileFailed } = deliverySlice.actions
export const deliveryReducer = deliverySlice.reducer

export function decodeOperationFilter(raw: unknown): OperationFilter | undefined {
  return OPERATION_FILTERS.find((filter) => filter === raw)
}
